import axios from "axios";
import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";

import Breadcrumbs from "../component/breadcrumbs";
import CustomHelmet from "../component/CustomHelmet";
import Form from "../component/Form";
import FormInput from "../component/FormInput";
import FormSingleCheckbox from "../component/FormSingleCheckbox";
import Intro from "../component/Intro";
import BaseContainer from "../component/layout/base-container";
import { setToken } from "../lib/authentication";
import { translate } from "../lib/translate";

export default function Login(params) {
  const location = useLocation();

  // States to keep track of stuff
  const [email, setEmail] = useState(
    location.state?.email ? location.state.email : ""
  );
  const [password, setPassword] = useState();
  const [showPassword, setShowPassword] = useState(false);

  const [loginError, setLoginError] = useState();

  const [staySignedIn, setStaySignedIn] = useState(false);

  const checkEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email) || !email) {
      setLoginError(["Bitte verwenden Sie eine gültige E-Mail Adresse"]);
      return;
    }
    setLoginError(null);
  };

  const signup = async (event) => {
    event.preventDefault();
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}auth/login/`,
        {},
        {
          auth: {
            username: email,
            password: password,
          },
        }
      );
      setToken(response.data.token, staySignedIn);
      window.location.href = "/dashboard";
    } catch (e) {
      if (e.response.status === 401) {
        const error_response = e.response.data;
        setLoginError(error_response["detail"]);
      } else {
        console.log(e);
      }
    }
  };

  return (
    <>
      <CustomHelmet pageTitle="Anmelden" />
      <Breadcrumbs
        listItems={[
          { name: "Home", url: "/" },
          { name: "Anmelden", url: "/anmelden" },
        ]}
      />
      <BaseContainer>
        <Intro title="Anmelden" />
        <Form>
          <p>
            Haben Sie noch keinen Account?
            <Link to="/registrieren" className="Link size-inherit">
              Jetzt Registrieren
            </Link>
          </p>
          <p>Bitte melden Sie sich mit Ihren Zugangsdaten an.</p>
          {loginError != null ? (
            <div className="FormMessage">
              <div
                className="FormMessage--inner js-Autofocus type-error"
                role="alert"
              >
                <div className="FormMessage--iconWrapper">
                  <span className="Icon" data-name="24--error">
                    <svg>
                      <use xlinkHref="#24--error"></use>
                    </svg>
                  </span>
                </div>
                <div className="FormMessage--body">
                  <div className="FormMessage--text richtext">
                    <p>Bei deiner Anmeldung hat etwas nicht geklappt:</p>
                    <ul>
                      <li>{translate(loginError)}</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            location.state && (
              <div className="FormMessage">
                <div
                  className="FormMessage--inner js-Autofocus type-success"
                  role="alert"
                >
                  <div className="FormMessage--iconWrapper">
                    <span className="Icon" data-name="24--success">
                      <svg>
                        <use xlinkHref="#24--success"></use>
                      </svg>
                    </span>
                  </div>
                  <div className="FormMessage--body">
                    <div className="FormMessage--text richtext">
                      <p>{location.state.message}</p>
                    </div>
                  </div>
                </div>
              </div>
            )
          )}
          <FormInput
            label="E-Mail"
            type="email"
            value={email}
            error={loginError != null}
            onInput={(e) => {
              setEmail(e.target.value);
              checkEmail(e.target.value);
            }}
            required
          />
          <FormInput
            label="Passwort"
            type={showPassword ? "text" : "password"}
            required
            error={loginError != null}
            onInput={(e) => {
              setPassword(e.target.value);
              setLoginError(null);
            }}
          />
          <button onClick={() => setShowPassword((prevState) => !prevState)}>
            {showPassword ? "Passwort verstecken" : "Passwort anzeigen"}
          </button>
          <FormSingleCheckbox
            label="Angemeldet bleiben"
            description="Diese Option sollte auf geteilten Computer nicht angewählt werden."
            checked={staySignedIn}
            onChange={() => setStaySignedIn((prevState) => !prevState)}
          />
          <div className="FormButtons">
            <Link to={"/passwort"}>Passwort vergessen?</Link>
            <button
              disabled={!(email && password)}
              className="Button color-primary size-large mb-8"
              style={{
                marginRight: "unset",
                marginLeft: "auto",
                ...(!(email && password) && {
                  backgroundColor: "rgba(var(--c-grey-light),1)",
                  color: "rgba(var(--c-black),0.6)",
                }),
              }}
              onClick={signup}
            >
              Anmelden
            </button>
          </div>
        </Form>
      </BaseContainer>
    </>
  );
}
